<template>
  <div id="contenedor-archivar-detalle">
    <v-btn @click="toggleArchivar" text rounded class="text-capitalize">
      <v-icon left>
        {{ archivar === true
        ? 'mdi-package-variant-closed-plus'
        : 'mdi-package-variant-closed-minus' }}
      </v-icon>
      {{ archivar === true ? 'Archivar' : 'Desarchivar' }}
    </v-btn>
  </div>
</template>

<script>
import TOGGLE_ARCHIVAR_DETALLE_OBSERVACION from '@/graphql/querys/administracion/auditorias/toggleObservacionDetalleCompleto.gql';

export default {
  name: 'ToggleArchivarDetalleObservacion',
  props: {
    idDetalle: {
      type: String,
      required: true,
    },
    archivar: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    async toggleArchivar() {
      await this.$apollo
        .mutate({
          mutation: TOGGLE_ARCHIVAR_DETALLE_OBSERVACION,
          variables: {
            id: this.idDetalle,
            completo: this.archivar,
          },
        })
        .then(() => {
          this.$emit('success');
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
    },
  },
};
</script>

<style lang="scss">

</style>
